import { painColorScale } from './painColors'

/**
 * CSSカスタムプロパティとして痛みカラーを設定
 */
export function setPainCSSVariables(): void {
  const root = document.documentElement

  // 各痛みレベルの色をCSS変数として設定
  Object.entries(painColorScale).forEach(([level, color]) => {
    root.style.setProperty(`--pain-color-${level}`, color)
  })

  // 追加のユーティリティ変数
  root.style.setProperty('--pain-color-normal', painColorScale[0])
  root.style.setProperty('--pain-color-light', painColorScale[10])
  root.style.setProperty('--pain-color-medium', painColorScale[50])
  root.style.setProperty('--pain-color-high', painColorScale[70])
  root.style.setProperty('--pain-color-critical', painColorScale[90])
  root.style.setProperty('--pain-color-death', painColorScale[100])
}

/**
 * 動的に痛みレベルに応じたCSS変数を設定
 */
export function setCurrentPainLevel(painLevel: number): void {
  const root = document.documentElement
  root.style.setProperty('--current-pain-level', String(painLevel))

  // 現在の痛みレベルに応じた色を計算して設定
  import('./painColors').then(({ getPainColor }) => {
    const color = getPainColor(painLevel)
    root.style.setProperty('--current-pain-color', color)

    // RGB値も設定（opacity調整用）
    const rgb = hexToRgb(color)
    if (rgb) {
      root.style.setProperty('--current-pain-r', String(rgb.r))
      root.style.setProperty('--current-pain-g', String(rgb.g))
      root.style.setProperty('--current-pain-b', String(rgb.b))
    }
  })
}

/**
 * HEX色をRGBに変換
 */
function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1]!, 16),
    g: parseInt(result[2]!, 16),
    b: parseInt(result[3]!, 16)
  } : null
}

/**
 * CSS用の痛みカラークラスを生成
 */
export function generatePainColorClasses(): string {
  return Object.entries(painColorScale)
    .map(([level, color]) => `
      .pain-${level} {
        color: ${color};
      }
      .bg-pain-${level} {
        background-color: ${color};
      }
      .border-pain-${level} {
        border-color: ${color};
      }
      .shadow-pain-${level} {
        box-shadow: 0 0 10px ${color};
      }
      .glow-pain-${level} {
        text-shadow: 0 0 8px ${color}, 0 0 16px ${color};
      }
    `).join('\n')
}